import React from 'react';
import { View } from 'react-native';
import Colors from '../constants/Colors';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import DisputesStack from './DisputesStack';
import MoneyStack from './MoneyStack';
import ProjectsStack from './ProjectsStack';
import ContractorsStack from './ContractorsStack';
import CustomersStack from './CustomersStack';
import NavOptions from '../constants/NavOptions';
import TabBarIcon from '../components/TabBarIcon';
import { DrawerActions } from '@react-navigation/native';
import UserState from '../src/contexts/UserState';

const Tab = createBottomTabNavigator();

const MainTabs = () => {
  const [user, setUser] = React.useContext(UserState);

  return (
    <View style={{ backgroundColor: Colors.blue, flex: 1, }}>
    <Tab.Navigator screenOptions={NavOptions.tabBar} initialRouteName='ProjectsStack'>
      <Tab.Screen
        name='ProjectsStack'
        options={{
          title: 'Projects',
          tabBarIcon: ({ color }) => <TabBarIcon name="md-construct" color={color} type='Ionicons' />,
        }}
        component={ProjectsStack}
      />
      <Tab.Screen
        name='MoneyStack'
        component={MoneyStack}
        options={{
          title: 'Money',
          tabBarIcon: ({ color }) => <TabBarIcon name="dollar" color={color} type='Foundation' size={52} style={{top:-4}} />,
        }}
      />
      {user.isContractor && 
        <Tab.Screen
          name='CustomersStack'
          component={CustomersStack}
          options={{
            title: 'Customers',
            tabBarIcon: ({ color }) => <TabBarIcon name="users" color={color} type='FontAwesome' size={36} />,
          }}
        />
      }
      {!user.isContractor &&
        <Tab.Screen
          name='ContractorsStack'
          component={ContractorsStack}
          options={{
            title: 'Contractors',
            tabBarIcon: ({ color }) => <TabBarIcon name="hard-hat" color={color} type='FontAwesome5' />,
          }}
        />
      }
      <Tab.Screen
        name='DisputesStack'
        component={DisputesStack}
        options={{
          title: 'Disputes',
          tabBarIcon: ({ color }) => <TabBarIcon name="face-agent" color={color} type='MaterialCommunityIcons' />,
        }}
      />
      <Tab.Screen
        name='More'
        children={() => null}
        options={{
          title: 'More',
          tabBarIcon: ({ color }) => <TabBarIcon name="more-horizontal" color={color} type='Feather' />,
        }}
        listeners={({ navigation }) => ({
          tabPress: e => {
            e.preventDefault();
            navigation.dispatch(DrawerActions.toggleDrawer());
          }
        })}
      />
    </Tab.Navigator>
    </View>
  )
}

export default MainTabs;